<template>
  <div v-if="isShow.isPOShow" class="po">
    <div class="po-logo"></div>
    <div class="po-title"></div>
    <div class="kv-left">
      <div class="kv-lf1 transTop"></div>
      <div class="kv-lf2 transTop"></div>
    </div>
    <div class="po-input-wp">
      <div class="po-in1"></div>
      <div class="po-in2 titleTrans">
        <div class="po-ring-wp">
          <div class="po-ring rotateIt"></div>
          <div class="po-ring-flower"></div>
        </div>
        <div class="po-input-box"></div>
        <input type="text" class="po-input" v-model="name" ref="ipName" />
      </div>
    </div>
    <div class="select-wp">
      <div class="btn1"></div>
      <div
        class="btn2"
        :class="isClicked ? '' : 'btn2__trans'"
        @click="showNext"
      ></div>
    </div>
    <div class="selfToast" v-show="isToastShow">
      {{ toastMsg }}
    </div>
  </div>
</template>

<script>
import { postData } from '../../assets/util'

export default {
  name: 'PageOne',
  props: {
    isShow: Object,
  },
  data() {
    return {
      isClicked: false,
      name: '',
      isToastShow: false,
      toastMsg: '',
    }
  },
  methods: {
    handleInput() {
      const ua = window.navigator.userAgent.toLocaleLowerCase()
      const isIOS = /iphone|ipad|ipod/.test(ua)
      const isAndroid = /android/.test(ua)

      const ipName = this.$refs.ipName
      if (ipName) {
        if (isIOS) {
          ipName.addEventListener('blur', () => {
            setTimeout(() => {
              window.scrollTo(
                0,
                Math.max(
                  document.body.clientHeight,
                  document.documentElement.clientHeight
                )
              )
            }, 20)
          })
        } else if (isAndroid) {
          const originHeight =
            document.documentElement.clientHeight || document.body.clientHeight
          window.addEventListener(
            'resize',
            () => {
              const resizeHeight =
                document.documentElement.clientHeight ||
                document.body.clientHeight
              if (resizeHeight < originHeight) {
                this.isLogo = false
                document.querySelector('.po').style.height = originHeight + 'px'
              }
            },
            false
          )
        }
      }
    },
    showNext() {
      this.isClicked = true
      setTimeout(() => {
        this.isClicked = false
      }, 300)
      if (!this.name) {
        this.showToast('请输入姓名')
      } else {
        this.checkName(this.name)
      }
    },
    checkName(name) {
      const URL = '/codes/jiandou/game.php/Home/Words/JDOU_words/'
      const cutName = name.slice(0, 5)
      postData(URL, { text: cutName })
        .then((res) => {
          if (res.status === 1) {
            this.name = res.msg
            this.$emit('sendName', this.name)
            setTimeout(() => {
              this.$emit('nextPage', 'isPTShow')
            }, 300)
          } else {
            this.showToast('请稍后重新输入')
          }
        })
        .catch((err) => console.error(err))
    },
    showToast(msg) {
      this.toastMsg = msg
      this.isToastShow = true
      setTimeout(() => {
        this.isToastShow = false
      }, 1500)
    },
    checkInput() {},
  },
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.po {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
}
.kv-left {
  position: absolute;
  top: 0;
  right: 0;
  width: 8.75/2rem /* 140/16 */;
  height: 100%;
  overflow: hidden;
  .kv-lf1 {
    width: 8.75/2rem /* 140/16 */;
    height: 149.3125/2rem /* 2389/16 */;
    .bg('../page-kv/img/kv-left.jpg');
  }
  .kv-lf2 {
    width: 8.75/2rem /* 140/16 */;
    height: 149.3125/2rem /* 2389/16 */;
    .bg('../page-kv/img/kv-left.jpg');
  }
}
.po-logo {
  position: absolute;
  top: 1.5rem;
  left: 4.625/2rem /* 74/16 */;
  width: 12.125/2rem /* 194/16 */;
  height: 5.875/2rem /* 94/16 */;
  .bg('./img/po-logo.png');
}
.po-title {
  position: absolute;
  top: 1.5rem;
  right: 5rem /* 80/16 */;
  width: 11.75/2rem /* 188/16 */;
  height: 7.25/2rem /* 116/16 */;
  .bg('./img/po-title.png');
}
.po-input-wp {
  position: relative;
}
.po-in1 {
  width: 34.375/2rem /* 550/16 */;
  height: 20.625/2rem /* 330/16 */;
  border: 1px solid #333;
  border-radius: 0.625rem /* 10/16 */;
  background-color: #ffe400;
}
.po-in2 {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 34.375/2rem /* 550/16 */;
  height: 20.625/2rem /* 330/16 */;
  padding: 1.6875rem /* 27/16 */ 1rem;
  box-sizing: border-box;
  border: 1px solid #333;
  border-radius: 0.625rem /* 10/16 */;
  background-color: #fff;
}
.po-input-box {
  width: 21.75/2rem /* 348/16 */;
  height: 3.125/2rem /* 50/16 */;
  .bg('./img/po-inputName.png');
}
.po-input {
  width: 100%;
  height: 2.75rem /* 44/16 */;
  margin-top: 1.5rem;
  background-color: #f2f2f2;
  border-radius: 0.625rem /* 10/16 */;
  box-shadow: inset 0 0 10px #f5dfd7;
  text-align: center;
}
.po-ring-wp {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  left: -7.125/4rem /* 114/16 */;
  top: -7.125/4rem /* 114/16 */;
  width: 7.125/2rem /* 114/16 */;
  height: 7.125/2rem /* 114/16 */;
  background-color: #fff;
}
.po-ring {
  position: absolute;
  left: 0;
  right: 0;
  width: 7.125/2rem /* 114/16 */;
  height: 7.0625/2rem /* 113/16 */;
  .bg('./img/po-ring.png');
}
.po-ring-flower {
  width: 4.125/2rem /* 66/16 */;
  height: 3.375/2rem /* 54/16 */;
  .bg('./img/po-flower.png');
}
.select-wp {
  position: relative;
  margin-top: 8rem;
  margin-right: 8rem;
}
.btn1 {
  width: 9.375rem /* 150/16 */;
  height: 2.5625rem /* 41/16 */;
  border-radius: 0.625rem /* 10/16 */;
  border: 1px solid #1a1a1a;
  background-color: #fff;
}
.btn2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 9.375rem /* 150/16 */;
  height: 2.5625rem /* 41/16 */;
  border-radius: 0.625rem /* 10/16 */;
  box-sizing: border-box;
  padding: 0.875/2rem /* 14/16 */ 0;
  border: 1px solid #1a1a1a;
  background-color: #1a1a1a;
  background-image: url('./img/po-select.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 1.4375rem /* 23/16 */;
  transition: transform 0.3s ease;
}
.btn2__trans {
  transform: translate(-3px, -3px);
}
.rotateIt {
  animation: rotateIt 10s linear infinite;
}
@keyframes rotateIt {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.titleTrans {
  animation: titleTrans 0.5s ease-in both;
}
@keyframes titleTrans {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(-10px, -10px);
  }
}
.transTop {
  animation: transTop 16s linear infinite;
}
@keyframes transTop {
  from {
    transform: translateZ(0) translateY(0);
  }
  to {
    transform: translateZ(0) translateY(-100%);
  }
}
.selfToast {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 10.8rem;
  padding: 0.75rem /* 12/16 */ 1rem;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 0.375rem /* 6/16 */;
  font-size: 1rem /* 16/16 */;
  color: #fff;
  text-align: center;
}
</style>
